import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Palette } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Projects', path: '/projects' },
    { name: 'Team', path: '/team' },
    { name: 'Contact', path: '/contact' },
  ]

  return (
    <nav data-component-path="client/src/components/Navbar.jsx" data-component-line="1:1" data-component-id="client/src/components/Navbar.jsx:1:1" 
         className={`fixed w-full z-50 transition-all duration-300 ${
           isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
         }`}>
      <div data-component-path="client/src/components/Navbar.jsx" data-component-line="2:3" data-component-id="client/src/components/Navbar.jsx:2:3" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Navbar.jsx" data-component-line="3:5" data-component-id="client/src/components/Navbar.jsx:3:5" className="flex justify-between items-center h-20">
          <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="4:7" data-component-id="client/src/components/Navbar.jsx:4:7" 
                to="/" 
                className="flex items-center gap-2 group">
            <Palette data-component-path="client/src/components/Navbar.jsx" data-component-line="5:9" data-component-id="client/src/components/Navbar.jsx:5:9" className="w-8 h-8 text-amber-600 flex-shrink-0 group-hover:rotate-12 transition-transform duration-300" />
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="6:9" data-component-id="client/src/components/Navbar.jsx:6:9">
              <span data-component-path="client/src/components/Navbar.jsx" data-component-line="7:11" data-component-id="client/src/components/Navbar.jsx:7:11" className="text-2xl font-bold text-gray-900 hero-title">Anu Mishra</span>
              <p data-component-path="client/src/components/Navbar.jsx" data-component-line="8:11" data-component-id="client/src/components/Navbar.jsx:8:11" className="text-xs text-amber-600 font-medium">Interior Design</p>
            </div>
          </Link>

          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="9:7" data-component-id="client/src/components/Navbar.jsx:9:7" className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="10:9" data-component-id="client/src/components/Navbar.jsx:10:9"
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-amber-600'
                    : 'text-gray-700 hover:text-amber-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="11:9" data-component-id="client/src/components/Navbar.jsx:11:9"
              to="/contact"
              className="h-11 px-6 bg-amber-600 text-white rounded-lg hover:bg-amber-700 flex items-center justify-center gap-2 focus:ring-4 focus:ring-amber-300/50 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Get Started
            </Link>
          </div>

          <button data-component-path="client/src/components/Navbar.jsx" data-component-line="12:7" data-component-id="client/src/components/Navbar.jsx:12:7"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isOpen ? (
              <X data-component-path="client/src/components/Navbar.jsx" data-component-line="13:9" data-component-id="client/src/components/Navbar.jsx:13:9" className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu data-component-path="client/src/components/Navbar.jsx" data-component-line="14:9" data-component-id="client/src/components/Navbar.jsx:14:9" className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {isOpen && (
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="15:5" data-component-id="client/src/components/Navbar.jsx:15:5" className="md:hidden py-4 border-t border-gray-200">
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="16:7" data-component-id="client/src/components/Navbar.jsx:16:7" className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="17:9" data-component-id="client/src/components/Navbar.jsx:17:9"
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`text-base font-medium transition-colors duration-200 ${
                    location.pathname === link.path
                      ? 'text-amber-600'
                      : 'text-gray-700 hover:text-amber-600'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="18:9" data-component-id="client/src/components/Navbar.jsx:18:9"
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="h-11 px-6 bg-amber-600 text-white rounded-lg hover:bg-amber-700 flex items-center justify-center gap-2 focus:ring-4 focus:ring-amber-300/50 transition-all duration-200 shadow-md hover:shadow-lg"
              >
                Get Started
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar